module.exports = __webpack_public_path__ + "img/difang.964a423d.png";